import type { ComponentProps } from 'react'
import TemplateExplorer from '../../../common/property-card/TemplateExplorer'
import GridTemplateCard, { isGridCardTemplate } from '../../../common/property-card/explorer-template-bridge'

type PropertyCardProps = ComponentProps<typeof TemplateExplorer>

/**
 * Card dispatcher for the explorer surfaces (grid, slider, recommendations)
 * and anyone else importing this path. The card.design templates (classic —
 * the default — / overlay / detailed) render the shared property-card
 * templates with full grid behavior: quote pricing, favorites, and
 * filter-carrying URLs travel through the bridge. 'default' renders
 * TemplateExplorer — the legacy card whose markup the #895 skin CSS targets —
 * kept selectable until #902 ports the skin to the template family.
 */
export default function PropertyCard(props: PropertyCardProps) {
  const template = props.options.card?.design
  if (isGridCardTemplate(template)) {
    return (
      <GridTemplateCard
        template={template}
        property={props.property}
        options={props.options}
        visitorFilters={props.visitorFilters}
        quoteData={props.quoteData}
        quoteLoading={props.quoteLoading}
        quoteFailed={props.quoteFailed}
        showFavoriteButton={props.showFavoriteButton}
        mapActions={props.mapActions}
        compare={props.compare}
      />
    )
  }
  return <TemplateExplorer {...props} />
}
